module.exports = __webpack_public_path__ + "img/no-buy.9dfb8a6f.svg";